import { HttpInterceptorFn, HttpErrorResponse, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { catchError, throwError, Observable, switchMap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // Endpoint tra cứu hồ sơ là public, kể cả khi browser còn phiên đăng nhập.
  // Không gửi Bearer và cũng không chạy refresh-token cho request này.
  if (req.url.includes('/api/v1/tracking-request')) {
    return next(req.clone({ headers: req.headers.delete('Authorization') }));
  }

  // Reset-password endpoints are public. Never attach or refresh a Bearer token for them.
  const authEndpoints = ['/auth/login', '/auth/register', '/auth/refresh', '/auth/logout', '/auth/verify', '/auth/introspect', '/auth/forgot-password', '/auth/reset-password'];
  const isAuthEndpoint = authEndpoints.some(endpoint => req.url.includes(endpoint));
  
  if (isAuthEndpoint) {
    return next(req.clone({ headers: req.headers.delete('Authorization') }));
  }

  // Get token and add to request header
  const token = authService.getAccessToken();
  
  let authReq = req;
  if (token) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Handle 401 Unauthorized errors
      if (error.status === 401) {
        console.warn(`[AuthInterceptor] Received 401 Unauthorized for URL: ${req.url}. Attempting to refresh token...`);
        return handle401Error(authReq, next, authService);
      }
      return throwError(() => error);
    })
  );
};

const handle401Error = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
  authService: AuthService
): Observable<any> => {
  const currentToken = authService.getAccessToken();
  const requestToken = req.headers.get('Authorization');

  // Request có thể trả 401 sau khi một request/tab khác đã refresh thành công.
  if (currentToken && requestToken !== `Bearer ${currentToken}`) {
    return next(
      req.clone({
        setHeaders: {
          Authorization: `Bearer ${currentToken}`
        }
      })
    );
  }

  return authService.refreshToken().pipe(
    switchMap((response) => next(
      req.clone({
        setHeaders: {
          Authorization: `Bearer ${response.access_token}`
        }
      })
    )),
    catchError((refreshError) => throwError(() => refreshError))
  );
};


